<template>
  <Tabs
    :value="value"
    :animated="false"
    class="tabHeight"
    @on-click="switchTabs"
  >
    <!-- 查询历史  -->
    <TabPane name="History" label="查询历史记录">
      <History
        ref="history"
        @selectRow="selectRow"
        @selectRowUpdate="selectRowUpdate"
      ></History>
    </TabPane>
    <!-- 保存的查询  -->
    <TabPane name="Saved" label="保存的查询">
      <Saved ref="save" @selectRowItem="selectRowItem"></Saved>
    </TabPane>

    <!-- 结果+图表 -->

    <!-- <TabPane name="Results" label="结果" class="tab-panel"> -->
    <TabPane v-if="selected" name="Results" label="结果" class="tab-panel">
      <ResultChart
        ref="results"
        :execute="execute"
        :param="param"
      ></ResultChart>
    </TabPane>
  </Tabs>
</template>
<script>
import History from "./history.vue";
// import Analysis from "./analysis.vue";
import ResultChart from "./resultChart.vue";
import Saved from "./save.vue";

export default {
  data() {
    return {
      value: "History",
      selected: false,
      // value: "Chart",
    };
  },
  props: {
    execute: Object,
    param: Object,
  },
  components: {
    History,
    // Analysis,
    Saved,
    ResultChart,
  },
  methods: {
    switchTabs(data) {
      this.value = data;
    },
    selectRow(content) {
      this.$emit("selectRow", content);
    },
    selectRowUpdate(content) {
      this.$refs.save.selectSave(content);
    },
    selectRowItem(content) {
      this.$emit("selectRowItem", content[0]);
    },
  },
};
</script>
<style scoped>
.tabHeight {
  overflow: visible !important;
  /* width: 1000px; */
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/tabs.vue